// actions
const SET = "users/SET";
const SET_SELECTED = "users/SET_SELECTED";
const SET_SEARCHING = "users/SET_SEARCHING";

const DEFAULT_STATE = {
  listing: [],
  selected: "",
  isSearching: false,
};

// reducer
const reducer = (state = DEFAULT_STATE, action: any = {}) => {
  switch (action.type) {
    case SET:
      return Object.assign({}, state, { listing: action.listing });
    case SET_SELECTED:
      return Object.assign({}, state, { selected: action.id });
    case SET_SEARCHING:
      return Object.assign({}, state, { isSearching: action.payload });
    default:
      return state;
  }
};

export default reducer;

// action creators
export const setListing = (listing: any[]) => ({ listing, type: SET });
export const setSelected = (id: string) => ({ id, type: SET_SELECTED });
export const setIsSearching = (payload: boolean) => ({
  payload,
  type: SET_SEARCHING,
});
